import { alpha } from "@mui/system";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 165px)",
    padding: 0,
    gap: 1,
  },
  paper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    bgcolor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
    borderRadius: 4,
    mx: 0,
    position: "relative",
  },
});

export default styles;
